import BaseStore from 'stores/BaseStore';

class SiteVerificationStore extends BaseStore {
  constructor() {
    super('site/cms-verifications', 'site/cms-verifications', { site_model: true });
  }
}

export default new SiteVerificationStore()
